/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * API specification of VisDefinitionAPI
 *
 * @class VisDefinitionAPISpec
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'visDefinition API',
					events: {
						propagationInfo: {
							info: {
								id: this.getId(),
								type: this.getType()
							},
							callStack: {
								name: 'getByType',
								params: [this.getType()]
							}
						},
						actions: {
							refresh: {
								type: 'refresh',
								getEventName: () => {
									return 'definition';
								},
								getUndoActions: () => [{ name: 'refresh' }]
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});